import React from 'react';
import { useTheme } from '@veneer/core';
import Config from 'app/common/js/utils/Config';

const AppLogo = () => {
  const theme = useTheme();
  return (
    <div>
      <img className='wex-logo' src={Config.get('assetsURL') + '/images/' + `hp_wxp_logo_${theme.mode}.svg`} alt='logo' />
    </div>
  );
};
export default AppLogo;
